<template>
  <!--card empty提示-->
  <tk-flex
    center
    column
    middle
    :style="{width: width + '%', minHeight: height + 'px'}"
    class="caption"
  >
    <div class="m-b-5">
      <tk-icon size="32" color="#d2d2d2">kongyemian</tk-icon>
    </div>
    <div>{{emptyMsg}}</div>
  </tk-flex>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number
    },
    emptyMsg: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
  .caption {
    color: #d2d2d2 !important;
  }
</style>
